
import { mapState } from 'vuex'
import { useHead } from '~/mixins/seo'

export default {
  mixins: [useHead],
  head() {
    return this.useHead(this.story)
  },
  computed: {
    ...mapState(['story']),
  },
  mounted() {
    this.$nextTick(() => {
      this.initStoryblok()
    })
  },
  beforeDestroy() {
    this.$ScrollTrigger.getAll().forEach((trigger) => {
      trigger.kill(true)
    })
  },
  methods: {
    initStoryblok() {
      // Use the input event for instant update of content
      this.$storybridge.on('input', (event) => {
        if (event.story.id === this.story.id) {
          // this.story.content = event.story.content
          this.$store.commit('setStory', event.story)
        }
      })
      // Use the bridge to listen the events
      this.$storybridge.on(['published', 'change'], (event) => {
        // window.location.reload()
        this.$nuxt.$router.go({
          path: this.$nuxt.$router.currentRoute,
          force: true,
        })
      })
    },
  },
}
